import EnumService from '../EnumService'

export default class TipoPlanoContaContabilEnumService extends EnumService{

    constructor(){
        super('enumMovPlanoContaContabil');
    }
  
  }